import { ProductAttribute, ProductAttributeKeys } from "@wttb/product-configurator";
import { useCallback } from "react";

import { ChoiceButton } from "@/common/components/form/choice-button";
import { useStoreProduct } from "@/features/product/contexts/product-context";
import { SingleOption } from "./single-choice-button-selector";

export function OrientationAttribute({
  options,
  attribute,
}: {
  options: SingleOption[];
  attribute: ProductAttribute;
}) {
  const { config, attributesHash, incompatibilitiesHash, setProductConfig, setSelectedOption } =
    useStoreProduct();

  const handleOnOrientationChange = useCallback(
    (valueId: string) => {
      const configToUpdate = { ...config, [attribute.key]: valueId };
      // Get current size value
      const currentSizeValueId = config![ProductAttributeKeys.Size];
      // Find incompatible to Orientation size value
      const incompatibleSizeValue = (incompatibilitiesHash[valueId] || []).find(
        (val) =>
          val.incompatibleAttribute.key === ProductAttributeKeys.Size &&
          val.attribute.key === attribute.key,
      );
      // Check if selected size value is incompatible
      if (
        typeof currentSizeValueId === "string" &&
        incompatibleSizeValue?.valueIds?.includes(currentSizeValueId)
      ) {
        // Find first Compatible size value
        const sizeAttributeValueIds = Object.keys(attributesHash[ProductAttributeKeys.Size]);
        const firstSizeCompatibleValueId = sizeAttributeValueIds.find(
          (id) => !incompatibleSizeValue?.valueIds?.includes(id),
        );
        // Set compatible size value to config
        if (firstSizeCompatibleValueId) {
          configToUpdate[ProductAttributeKeys.Size] = firstSizeCompatibleValueId;
          setSelectedOption(ProductAttributeKeys.Size, firstSizeCompatibleValueId);
        }
      }

      setSelectedOption(ProductAttributeKeys.Orientation, valueId);
      setProductConfig(configToUpdate);
    },
    [
      attribute.key,
      attributesHash,
      config,
      incompatibilitiesHash,
      setProductConfig,
      setSelectedOption,
    ],
  );

  return (
    <div className="grid grid-cols-2 gap-6 text-center">
      {options?.map((option: SingleOption) => (
        <ChoiceButton
          {...option}
          onInputChange={() => handleOnOrientationChange(option.id)}
          key={option.id}
          isChecked={option.value === config![attribute.key]}
          type="radio"
          disabled={false}
        />
      ))}
    </div>
  );
}
